// T-272 — Documento HTML per la stampa via driver di sistema (PWA Chrome su
// Windows). Logica PURA (niente DOM, niente Capacitor) così è testabile in
// node: prende il PNG dell'etichetta già renderizzata (renderLabelCanvas, 203
// DPI) e produce un documento dimensionato in mm da iniettare in un iframe
// nascosto e mandare a `window.print()`. Il driver Windows della stampante
// (es. Meteor Mirò) gestisce la rasterizzazione / l'EPL2.

export interface SystemPrintDocumentOptions {
  /** Data URL PNG dell'etichetta (1 px = 1 dot @203 DPI). */
  pngDataUrl: string;
  /** Larghezza fisica dell'etichetta in mm (da template.width_mm). */
  widthMm: number;
  /** Altezza fisica dell'etichetta in mm (da template.height_mm). */
  heightMm: number;
  /** Numero di copie = numero di pagine di stampa. */
  copies: number;
  /** Titolo del documento (diagnostica; non stampato). */
  title?: string;
}

/** Escape per inserire una stringa dentro un attributo HTML quotato. */
function escapeAttr(s: string): string {
  return s.replace(/[&<>"']/g, (c) =>
    ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c] as string),
  );
}

/**
 * Costruisce il documento HTML di stampa. Una pagina per copia: ogni pagina è
 * dimensionata ESATTAMENTE come l'etichetta (`@page size` + box in mm) con
 * `margin: 0`, e l'immagine è renderizzata a misura fisica 1:1 senza
 * interpolazione (`image-rendering: pixelated`) per non sfocare barcode/QR.
 */
export function buildSystemPrintDocument(opts: SystemPrintDocumentOptions): string {
  const { pngDataUrl, widthMm, heightMm } = opts;
  const copies = Number.isFinite(opts.copies) && opts.copies > 0 ? Math.floor(opts.copies) : 1;
  const src = escapeAttr(pngDataUrl);
  const title = escapeAttr(opts.title ?? 'Etichetta TrackEAT');

  const page =
    `<div class="lbl" data-label-page>` +
    `<img src="${src}" alt="Etichetta" /></div>`;
  const pages = page.repeat(copies);

  return (
    `<!doctype html><html lang="it"><head><meta charset="utf-8" />` +
    `<title>${title}</title><style>` +
    `@page { size: ${widthMm}mm ${heightMm}mm; margin: 0; }` +
    `html, body { margin: 0; padding: 0; }` +
    `.lbl { width: ${widthMm}mm; height: ${heightMm}mm; ` +
    `overflow: hidden; page-break-after: always; break-after: page; }` +
    `.lbl:last-child { page-break-after: auto; break-after: auto; }` +
    `.lbl img { display: block; width: ${widthMm}mm; height: ${heightMm}mm; ` +
    `image-rendering: pixelated; image-rendering: crisp-edges; }` +
    `</style></head><body>${pages}</body></html>`
  );
}
